"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.MediaPopinEntity = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../../types");
var fields_1 = require("../../fields");
var slices_1 = require("../../slices");
var popin_factory_1 = require("./popin-factory");
exports.MediaPopinEntity = popin_factory_1.popinFactory(types_1.DocumentType.MEDIA_POPIN, function (prismicDoc, normalizedPopin, logger) {
    var _a, _b;
    var hashtag = fields_1.toText(prismicDoc.data.hashtag);
    if (hashtag && !hashtag.startsWith('#')) {
        hashtag = "#" + hashtag;
    }
    return utils_1.compact(__assign(__assign({}, normalizedPopin), { hashtag: hashtag, category: fields_1.toText(prismicDoc.data.category), image: fields_1.toImage(prismicDoc.data.image, logger), body_left: slices_1.toSlices((_a = prismicDoc.data) === null || _a === void 0 ? void 0 : _a.body_left_slices, logger), body_right: slices_1.toSlices((_b = prismicDoc.data) === null || _b === void 0 ? void 0 : _b.body_right_slices, logger) }));
});
//# sourceMappingURL=media-popin.js.map